import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { ReviewsPhotosRequestProps, ReviewsPhotosResponse } from '../types/fetch-models';

export function* fetchReviewsPhotosPage(props: ReviewsPhotosRequestProps, config: ApiRequestConfig) {
  const data = yield* get<ReviewsPhotosResponse>('reviews-photos', { ...props }, config);

  return data;
}
